<template>
  <div>
    <custom-actions show-back>
      <el-form class="global-form shoufa-form" :model="formData" :rules="rules" ref="form" label-width="130px"
        v-loading="loading">

        <el-row :span="24">
          <el-col :span="12">
            <el-form-item prop="status" label="状态">
              <el-radio-group v-model="formData.status">
                <el-radio label="1">空闲</el-radio>
                <el-radio label="2">工作中</el-radio>
                <el-radio label="3">外出</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="plateNumber" label="车牌号">
              <el-input v-model="formData.plateNumber" clearable placeholder="请输入车牌号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driver" label="司机姓名">
              <el-input v-model="formData.driver" clearable placeholder="请输入司机姓名"></el-input>

            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="driverPhone" label="司机手机">
              <el-input v-model="formData.driverPhone" clearable placeholder="请输入司机手机"></el-input>

            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item class="btn">
              <el-button @click="$router.back()">取消</el-button>
              <el-button type="primary" @click="submit">提交</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

    </custom-actions>

  </div>
</template>

<script>
import { validPhoneNumber } from '@/utils/validator.js'

export default {
  name: 'vehicleManageAdd',

  data () {
    return {
      formData: {

        plateNumber: '',
        status: '',
        driver: '',
        driverPhone: ''
      },

      rules: {

        status: [
          {
            required: true,
            message: '请选择状态',
            trigger: ['blur', 'change']
          }
        ],
        plateNumber: [
          {
            required: true,
            message: '请输入车牌号',
            trigger: ['blur', 'change']
          }
          // {
          //   validator: (rule, value, callback) => validateLicensePlate(rule, value, callback)

          // }
        ],
        driver: [
          {
            required: true,
            message: '请输入司机姓名',
            trigger: ['blur', 'change']
          }
        ],
        driverPhone: [
          {
            required: true,
            message: '请输入司机手机',
            trigger: ['blur', 'change']
          },
          { pattern: validPhoneNumber, message: '手机号格式错误' }

        ]

      },
      loading: false

    }
  },
  created () {
    if (this.plateId) {
      this.loadData()
    }
  },
  computed: {
    plateId () {
      return this.$route.query.plateId
    }

  },
  methods: {

    loadData () {
      this.loading = true
      this.$axios
        .get(this.$apis.vehicleManage.selectPaVehicleInfoByPlateId, {
          params: { plateId: this.plateId }
        })
        .then(res => {
          this.formData = res
        })
        .finally(() => {
          this.loading = false
        })
    },

    submit () {
      this.$refs.form
        .validate()
        .then(() => {
          this.loading = true

          let url = this.$apis.vehicleManage.insertPaVehicleInfo
          if (this.plateId) {
            url = this.$apis.vehicleManage.updatePaVehicleInfo
          }

          this.$axios.post(url, { ...this.formData }).then(() => {
            this.$router.back()
          })
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep .el-form {

  .el-input-number,
  .el-select,
  .el-input,
  .el-cascader,
  .el-date-editor {
    width: 100%;
    max-width: 400px;
  }
}

::v-deep .btn {
  .el-form-item__content {
    display: flex;
    margin-left: 0;
    align-items: center;
    justify-content: center;
  }
}
</style>
